const invoice = () => import('../pages/invoice/index.vue');
const invoiceDetail = () => import('../pages/invoice/invoiceDetail.vue');
const invoicePreview = () => import('../pages/invoice/invoicePreview.vue');

export default [
  {
    path: '/invoiceIndex',
    component: invoice,
  },
  {
    path: '/invoiceDetail',
    component: invoiceDetail,
  },
  {
    path: '/invoicePreview',
    component: invoicePreview,
  },
];
